import React from 'react'
import './custom-button.scss'
import { CustomButtonInterface } from '../../utils/constants/Interfaces.constants'

const CustomButton: React.FunctionComponent<CustomButtonInterface> = ({
    children,
    disabled = false,
    theme = 'primary',
    type = 'button',
    size = 'sm',
    onClick
}) => {
    // c-button-${theme}
    return (
        <button
            className={`c-button text-capitalize c-button-${theme} c-button-${size}`}
            disabled={disabled}
            type={type}
            onClick={onClick}
        >
            { children }
        </button>
    )
}

export default CustomButton